<template>
    <v-card :title="title" >
        <template slot="extra" v-if="moreUrl">
            <a :href="moreUrl" style="color: #eef0f1">MORE+</a>
        </template>
        <div style="padding: 10px">
            <Row>
                <Col :span="8">
                    <Carousel :autoplay="true" :loop="true" dots="none" arrow="never">
                        <CarouselItem v-for="item in imgList">
                            <router-link :to="item.link" class="image-item" >
                                <img :style="styleFormat"  :src="item.src" >
                            </router-link>
                        </CarouselItem>
                    </Carousel>
                </Col>
                <Col :span="16">
                    <ul class="list-wrap" style="padding-left: 10px;">
                        <li class="list-item" v-for="item in list">
                            <router-link class="item-title" :to="item.link||''" >
                                <Icon type="ios-arrow-forward" />
                                {{item.title}}
                            </router-link>
                            <span class="item-time">{{item.time}}</span>
                        </li>
                    </ul>
                </Col>
            </Row>
        </div>
    </v-card>
</template>

<script>
    import VCard from "./Card";
    export default {
        name: "vImageNewsCard",
        props:['title','imgList','list','moreUrl','height'],
        computed:{
            styleFormat(){
                return {
                    height:'196px',
                    width:'333px'
                }
            }
        },
        components:{VCard},
        methods:{
        }
    }
</script>

<style lang="less" scoped>
    .image-item{
        display: block;
        position: relative;
        text-align: center;
        & > img{
            max-width: 100%;
            height: 100%;
            margin: 0 auto;
        }
    }
    .list-wrap{
        list-style: none;
        margin: 8px 0;

        & .list-item{
            height: 30px;
            line-height: 30px;
            display: flex;
            font-size: 14px;

            & .item-title{
                color: #8A8A8A;
                flex: 1;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow: hidden;
                padding-left: 8px;
            }
            & .item-time{
                padding: 0 8px;
                color: #999999;
            }
        }
    }
</style>